<template>
  <div>
    <div class="loading" v-if="!productStore.manageIsLoaded">
      در حال بارگذاری...
    </div>
    <div class="product-inner" v-else-if="productStore.manageCards.length > 0">
      <ProductCardShablone v-for="product in productStore.manageCards" :key="product.id" :reaction="false" :card="product" :edit="true" :showOne="false"/>
    </div>
    <div v-else class="none-cart-error">
      شما سفارشی ندادید
    </div>
    <div ref="el" v-if="productStore.manageHasMore"></div>
  </div>
</template>
<script setup>
  import { useTemplateRef } from 'vue'
  import { useInfiniteScroll } from '@vueuse/core'
  import { useProductStore } from '@/stores/product'
  import { useAlertStore } from '@/stores/alert'
  import ProductCardShablone from '@/components/dashboard/bodys/product/card/ProductCardShablone.vue'
  import { polling } from '@/composables/polling'
  import { isDefrentProductData } from '@/composables/polling/isDefrentProductData'
  const productStore = useProductStore()
  const alertStore = useAlertStore()
  const el = useTemplateRef('el')
  polling( 
    async () => await productStore.fetchManageProduct(productStore.manageCards.length > 0 ? productStore.manageCards.length : 10 , 0 , false),
    {
      oldData:productStore.manageCards??[],
      intervalMs: 6000,
      isDifferent: (newData) => isDefrentProductData(productStore.manageCards,newData),
      onChange: (allNewProduct) => {
        if(isDefrentProductData(productStore.manageCards??[],allNewProduct??[])){
          if(productStore.manageCards.length<allNewProduct.length){
            alertStore.type=true
            alertStore.msg='سفارش جدید رسید!'
          }
          productStore.manageCards = allNewProduct??[]
        }
      }
    }
  )
  useInfiniteScroll(
    el, 
    async () => {
      await productStore.fetchManageProduct(10,productStore.manageCards.length,true) 
    } , { 
      distance: 50,
      canLoadMore: () => { 
        return productStore.manageHasMore
      } 
    }
  )
</script>
<style scoped>
    .product-inner {
        width: 100%;
        direction: rtl;
        height: 100%;
        display: flex;
        flex-direction: row-reverse;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: center;
        align-items: stretch;
    }
    .loading,.none-cart-error{
        text-align: center;
        padding: 20px;
        color: white;
        font-size: 20px;
        border-radius: 10px;
        box-shadow: 0 0 10px grey;
        font-weight: bold;
    }
    .loading{
        background: rgb(16, 16, 143);
    }
    .scroll-trigger {
        height: 1px;
    }
    .none-cart-error {
        background: rgb(128, 12, 12);
    }
</style>
